import { Routes } from "@angular/router";

export const Full_ROUTES: Routes = [
  {
    path: "dashboard",
    loadChildren: () => import("../../dashboard/dashboard.module").then((m) => m.DashboardModule)
  },
  {
    path: "tasks",
    loadChildren: () => import("../../task/task.module").then((m) => m.TaskModule)
  },
  {
    path: "stock-products",
    loadChildren: () => import("../../stock-products/stock-products.module").then((m) => m.StockProductsModule)
  },
  {
    path: "invoices",
    loadChildren: () => import("../../invoices/invoice.module").then((m) => m.InvoiceModule)
  },
  {
    path: "service-requests",
    redirectTo: "pages/service-requests",
    pathMatch: "full"
  },
  {
    path: "sub-users",
    redirectTo: "pages/sub-users",
    pathMatch: "full"
  },
  {
    path: "pages",
    loadChildren: () => import("../../pages/full-pages/full-pages.module").then((m) => m.FullPagesModule)
  }
];
